import { history } from '@umijs/max';
import { clearToken } from '@/services/auth/wecom';

const loginPath = '/user/login';
const LOGIN_PATHS = ['/user/login', '/user/register', '/user/register-result'];

function isLoginPath(pathname: string) {
  return LOGIN_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

/** 清除本地登录态并跳转登录页（401 / 会话失效） */
export function redirectToLogin(reason?: string) {
  if (typeof window === 'undefined') return;
  const { pathname, search, hash } = history.location;
  if (isLoginPath(pathname)) return;

  clearToken();

  const redirect = `${pathname}${search}${hash}`;
  const params = new URLSearchParams({
    redirect,
    ...(reason ? { reason } : {}),
  });
  history.replace(`${loginPath}?${params.toString()}`);
}

/** HTTP 401 或后端返回未登录 */
export function handleUnauthorized() {
  redirectToLogin('session_expired');
}
